
import { Product } from "domain/entities/shop/product/product";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    showImagesCarousel: {
      type: Number,
      required: true,
    },
    currentSlide: {
      type: Number,
      required: true,
    },
    openImageModal: {
      type: Function as PropType<(currentSlide: number) => number>,
      required: true,
    },
  },
});
